'use client';

import { c as _c } from "react/compiler-runtime";
import { MapSolid } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { AccommodationStaysMapSheet } from '~/components/TripOverview/accommodationPage/AccommodationStaysMapSheet';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import { ItineraryTimeline } from './ItineraryTimeline';
import styles from './ItineraryTimeline.module.css';
import type { TripItineraryProps } from './TripItinerary.types';
export const TripItinerary = t0 => {
  const $ = _c(35);
  const {
    groups,
    originLocationName,
    isEditable,
    tripId,
    returnLegId,
    cardSection: t1,
    sectionHeadingKey,
    accommodationStaysByItemId,
    desktopTransparent: t2
  } = t0;
  const cardSection = t1 === undefined ? "overview" : t1;
  const desktopTransparent = t2 === undefined ? false : t2;
  const t = useTranslations("journey");
  const isDesktop = useIsDesktop();
  const [isAccommodationMapOpen, setIsAccommodationMapOpen] = useState(false);
  const showSeeOnMapButton = cardSection === "accommodation" && !isDesktop;
  const t3 = desktopTransparent && styles.itinerarySectionNoDesktopSpacing;
  let t4;
  if ($[0] !== t3) {
    t4 = clsx(styles.itinerarySection, t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = desktopTransparent && styles.frameNoDesktopBackground;
  let t6;
  if ($[2] !== t5) {
    t6 = clsx(styles.frame, t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== sectionHeadingKey || $[5] !== t) {
    t7 = sectionHeadingKey ? t(sectionHeadingKey) : t("overview_itinerary_drawer_aria_label");
    $[4] = sectionHeadingKey;
    $[5] = t;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t7) {
    t8 = <h3 className={styles.heading} id="itinerary-heading">{t7}</h3>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== showSeeOnMapButton || $[10] !== t) {
    t9 = showSeeOnMapButton ? <button type="button" className={styles.seeOnMapButton} data-test-id="accommodation-see-on-map" onClick={() => setIsAccommodationMapOpen(true)}><MapSolid decorative={true} size="small" />{t("accommodation_see_on_map")}</button> : null;
    $[9] = showSeeOnMapButton;
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <div className={styles.headingRow}>{t8}{t9}</div>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== accommodationStaysByItemId || $[16] !== cardSection || $[17] !== groups || $[18] !== isEditable || $[19] !== originLocationName || $[20] !== returnLegId || $[21] !== tripId) {
    t11 = <ItineraryTimeline groups={groups} originLocationName={originLocationName} isEditable={isEditable} tripId={tripId} returnLegId={returnLegId} cardSection={cardSection} accommodationStaysByItemId={accommodationStaysByItemId} />;
    $[15] = accommodationStaysByItemId;
    $[16] = cardSection;
    $[17] = groups;
    $[18] = isEditable;
    $[19] = originLocationName;
    $[20] = returnLegId;
    $[21] = tripId;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t6) {
    t12 = <div className={t6}>{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== cardSection || $[28] !== isAccommodationMapOpen || $[29] !== tripId) {
    t13 = cardSection === "accommodation" && isAccommodationMapOpen ? createPortal(<AccommodationStaysMapSheet tripId={tripId} onClose={() => setIsAccommodationMapOpen(false)} />, globalThis.document.body) : null;
    $[27] = cardSection;
    $[28] = isAccommodationMapOpen;
    $[29] = tripId;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t4) {
    t14 = <section className={t4} aria-labelledby="itinerary-heading">{t12}{t13}</section>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t4;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
};